import { render, staticRenderFns } from "./MyLayout.vue?vue&type=template&id=b65cdf48&"
import script from "./MyLayout.vue?vue&type=script&lang=js&"
export * from "./MyLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports